// // File: ReportPage.jsx
// import React, { useEffect, useState, useRef } from 'react';

// import {
//   Box,
//   Tabs,
//   Tab,
//   Typography,
//   TextField,
//   Grid,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
// } from '@mui/material';

// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// import { SalesReport } from './report/SalesReport';
// import { OrderReport } from './report/ OrderReport';
// import { PaymentReport } from './report/PaymentReport';
// import { CustomReports } from './report/CustomReports';
// import { useAuth } from '../../hooks/useAuth';
// import { getBulkOrderData, getCurrentOrder } from '../../hooks/apiHandler';
// import { fetchTimeandDateRange } from '../../hooks/commanFunc';
// import { EmployeeShiftReport } from './report/EmployeeShiftReport';

// const reportTabs = [
//   'Sales Summary',
//   'Order Report',
//   'Payment Methods',
//   'Employee Shifts',
//   'Custom Report',
// ];

// // const reportRanges = ['today', 'yesterday', 'weekly', 'bi-weekely', 'monthly'];
// const reportRanges = [
//   { value: "today", label: "Today" },
//   { value: "yesterday", label: "Yesterday" },
//   { value: "weekly", label: "Weekly" },
//   { value: "bi-weekly", label: "Bi-Weekly" },
//   { value: "last30Days", label: "30 Days" },
// ];

// // const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];

// const ReportPage = () => {
//   const [tabIndex, setTabIndex] = useState(0);
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [reportRange, setReportRange] = useState('today');
//   const [updateDate, setUpdateDate] = useState(false);
//   const [serverData, setServerData] = useState(null);
//   const [rawServerData, setRawServerData] = useState(null);

//   const today = new Date();
//   const start = new Date(today);
//   const end = new Date(today);

//   const { Logout } = useAuth();
//   const storeID = useRef(JSON.parse(window.localStorage.getItem("ds")));

//   useEffect(() => {
//     async function fetchOrders() {
//       try {
//         let response;

//         if (reportRange === 'yesterday') {

//           start.setDate(start.getDate() - 1);
//           start.setHours(0, 0, 0, 0);


//           end.setDate(end.getDate() - 1);
//           end.setHours(23, 59, 59, 999);


//           setStartDate(start);
//           setEndDate(end);

//           response = await getCurrentOrder({
//             storeID: storeID.current,
//             startdate: start.toISOString(),
//             enddate: end.toISOString(),
//           }, Logout);
//         } else {
//           // Assume today
//           const start = new Date();
//           start.setHours(0, 0, 0, 0);

//           const end = new Date();
//           end.setHours(23, 59, 59, 999);

//           setStartDate(start);
//           setEndDate(end);

//           response = await getCurrentOrder({
//             storeID: storeID.current,
//           }, Logout);
//         }
//         if (response?.data) {
//           setServerData(response?.data);
//           setRawServerData(response?.data);
//         } else {
//           setServerData();
//         }
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     }

//     async function fetchBulkData() {
//       try {
//         console.log("Selected Report Range:", reportRange);

//         const { start, end } = await fetchTimeandDateRange(reportRange);

//         setStartDate(start);
//         setEndDate(end);

//         // NOTE: Ensure these keys match your backend API (e.g., startDate vs startdate)
//         const response = await getBulkOrderData({
//           storeID: storeID.current,
//           startdate: start.toISOString(),
//           enddate: end.toISOString(),
//         }, Logout);

//         console.log(response.data);
//         setRawServerData(response.data);

//         /// only need to create single doc from dailydata array..

//         if (response?.data.dailyData && Array.isArray(response.data.dailyData) && response.data.dailyData.length > 0) {
//           const dailyOrdersArray = response.data.dailyData;
//           console.log(dailyOrdersArray);

//           // FIX: The initial state now uses the original object keys
//           const initialState = {
//             storeID: dailyOrdersArray[0].storeID,
//             openingTime: dailyOrdersArray[0].openingTime, // Renamed from startDate
//             closingTime: dailyOrdersArray[dailyOrdersArray.length - 1].closingTime, // Renamed from endDate
//             c_order: 0,
//             totalSales: 0,
//             totalDiscount: 0,
//             totalTips: 0,
//             openingCash: 0,
//             tillCash: 0, // Will hold the final till cash
//             cashDrops: [],       // Using original key
//             paidOuts: [],        // Using original key
//           };

//           // Use reduce() to process the array and build the summary
//           const summaryReport = dailyOrdersArray.reduce((summary, currentDay) => {
//             summary.cashDrops.push(...currentDay.cashDrops);
//             summary.paidOuts.push(...currentDay.paidOuts);

//             // The last day's tillCash will become the final value
//             summary.openingCash += currentDay.openingCash;
//             summary.totalSales += currentDay.totalSales || 0;
//             summary.totalDiscount += currentDay.totalDiscount || 0;
//             summary.totalTips += currentDay.totalTips || 0;
//             summary.tillCash += currentDay.tillCash;

//             return summary;
//           }, initialState);

//           // Set the final processed summary report into state
//           setServerData({
//             dailyData: summaryReport,
//             orders: response.data.orders
//           });

//         } else {
//           // If there's no data, clear the state
//           setServerData(null);
//         }
//       } catch (error) {
//         console.error("Error fetching or processing bulk data:", error);
//       }
//     }
//     if (reportRange === "today" || reportRange === "yesterday") {
//       console.log('This is time to fetch Data : ', reportRange);
//       fetchOrders();
//     } else {
//       console.log('Handle Multiple daily Order Data....')
//       fetchBulkData();
//     }

//   }, [reportRange, Logout]);
//   // Body
//   return (
//     <Box sx={{ p: 2 }}>
//       <Typography variant="h4" gutterBottom>
//         POS Reports
//       </Typography>

//       <Tabs
//         value={tabIndex}
//         onChange={(e, newIndex) => setTabIndex(newIndex)}
//         sx={{ mb: 2 }}
//       >
//         {reportTabs.map((label, index) => (
//           <Tab label={label} key={index} />
//         ))}
//       </Tabs>

//       <LocalizationProvider dateAdapter={AdapterDateFns}>
//         <Grid container spacing={2} direction="row"
//           sx={{
//             justifyContent: "flex-end",
//             alignItems: "center",
//           }}>
//           {tabIndex === 4 && (<>
//             <Grid item xs={12} md={3}>
//               <DatePicker
//                 label="Start Date"
//                 value={startDate}
//                 onChange={(newVal) => {
//                   const properDate = new Date(newVal);
//                   properDate.setHours(0, 0, 0, 0);
//                   setStartDate(properDate);
//                 }}
//                 onAccept={() => {
//                   setUpdateDate(!updateDate);
//                 }}
//                 renderInput={(params) => (
//                   <TextField {...params} fullWidth size="small" />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12} md={3}>
//               <DatePicker
//                 label="End Date"
//                 value={endDate}
//                 onChange={(newVal) => {
//                   const properDate = new Date(newVal);
//                   properDate.setHours(23, 59, 59, 999);
//                   setEndDate(properDate);
//                 }}
//                 onAccept={() => {
//                   setUpdateDate(!updateDate);
//                 }}
//                 renderInput={(params) => (
//                   <TextField {...params} fullWidth size="small" />
//                 )}
//               />
//             </Grid> </>)}
//           <Grid item xs={12} md={3}>
//             <FormControl fullWidth size="small">
//               <InputLabel id="report-range-label">Report Range</InputLabel>
//               <Select
//                 labelId="report-range-label"
//                 value={reportRange}
//                 label="Report Range"
//                 onChange={(e) => setReportRange(e.target.value)}
//               >
//                 {reportRanges.map((range) => (
//                   <MenuItem value={range.value} key={range.value}>
//                     {range.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//         </Grid>
//         <br />
//       </LocalizationProvider>

//       <Box sx={{ mt: 3 }} > {/* this willl help to create print report.... */}

//         {tabIndex === 0 && (
//           <SalesReport reportRange={reportRange} rawData={serverData} />
//         )}
//         {tabIndex === 1 && (
//           <OrderReport reportRange={reportRange} rawData={serverData} />
//         )}
//         {tabIndex === 2 && (
//           <PaymentReport reportRange={reportRange} rawData={serverData} />
//         )}
//         {tabIndex === 3 && (
//           <EmployeeShiftReport reportRange={reportRange} />
//         )}
//         {tabIndex === 4 && (
//           /// We are Still working on custom reports.
//           <CustomReports storeID={storeID.current} startDate={startDate} endDate={endDate} rawDataParent={rawServerData} />
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default ReportPage;

// File: ReportPage.jsx
import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { SalesReport } from './report/SalesReport';
import { OrderReport } from './report/ OrderReport';
import { PaymentReport } from './report/PaymentReport';
import { CustomReports } from './report/CustomReports';
import { useAuth } from '../../hooks/useAuth';
import { getBulkOrderData, getCurrentOrder } from '../../hooks/apiHandler';
import { fetchTimeandDateRange } from '../../hooks/commanFunc';
import { EmployeeShiftReport } from './report/EmployeeShiftReport';

const reportTabs = [
  'Sales Summary',
  'Order Report',
  'Payment Methods',
  'Employee Shifts',
  'Custom Report',
];

const reportRanges = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "weekly", label: "Weekly" },
  { value: "bi-weekly", label: "Bi-Weekly" },
  { value: "last30Days", label: "30 Days" },
];

const ReportPage = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [reportRange, setReportRange] = useState('today');
  const [updateDate, setUpdateDate] = useState(false);
  const [serverData, setServerData] = useState(null);
  const [rawServerData, setRawServerData] = useState(null);

  const today = new Date();
  const start = new Date(today);
  const end = new Date(today);

  const { Logout } = useAuth();
  // Safe parsing in case localStorage is empty
  const storeID = useRef(
    window.localStorage.getItem("ds") 
      ? JSON.parse(window.localStorage.getItem("ds")) 
      : null
  );

  useEffect(() => {
    async function fetchOrders() {
      if (!storeID.current) return; // Guard clause

      try {
        let response;
        if (reportRange === 'yesterday') {
          start.setDate(start.getDate() - 1);
          start.setHours(0, 0, 0, 0);

          end.setDate(end.getDate() - 1);
          end.setHours(23, 59, 59, 999);

          setStartDate(start);
          setEndDate(end);

          response = await getCurrentOrder({
            storeID: storeID.current,
            startdate: start.toISOString(),
            enddate: end.toISOString(),
          }, Logout);
        } else {
          // Assume today
          const start = new Date();
          start.setHours(0, 0, 0, 0);

          const end = new Date();
          end.setHours(23, 59, 59, 999);

          setStartDate(start);
          setEndDate(end);

          response = await getCurrentOrder({
            storeID: storeID.current,
          }, Logout);
        }
        if (response?.data) {
          setServerData(response?.data);
          setRawServerData(response?.data);
        } else {
          setServerData(null);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    }

    async function fetchBulkData() {
      if (!storeID.current) return;

      try {
        // console.log("Selected Report Range:", reportRange);
        const { start, end } = await fetchTimeandDateRange(reportRange);

        setStartDate(start);
        setEndDate(end);

        const response = await getBulkOrderData({
          storeID: storeID.current,
          startdate: start.toISOString(),
          enddate: end.toISOString(),
        }, Logout);

        // console.log(response.data);
        setRawServerData(response.data);

        if (response?.data.dailyData && Array.isArray(response.data.dailyData) && response.data.dailyData.length > 0) {
          const dailyOrdersArray = response.data.dailyData;

          const initialState = {
            storeID: dailyOrdersArray[0].storeID,
            openingTime: dailyOrdersArray[0].openingTime,
            closingTime: dailyOrdersArray[dailyOrdersArray.length - 1].closingTime,
            c_order: 0,
            totalSales: 0,
            totalDiscount: 0,
            totalTips: 0,
            openingCash: 0,
            tillCash: 0,
            cashDrops: [],
            paidOuts: [],
          };

          const summaryReport = dailyOrdersArray.reduce((summary, currentDay) => {
            summary.cashDrops.push(...currentDay.cashDrops);
            summary.paidOuts.push(...currentDay.paidOuts);
            summary.openingCash += currentDay.openingCash;
            summary.totalSales += currentDay.totalSales || 0;
            summary.totalDiscount += currentDay.totalDiscount || 0;
            summary.totalTips += currentDay.totalTips || 0;
            summary.tillCash += currentDay.tillCash;
            return summary;
          }, initialState);

          setServerData({
            dailyData: summaryReport,
            orders: response.data.orders
          });
        } else {
          setServerData(null);
        }
      } catch (error) {
        console.error("Error fetching or processing bulk data:", error);
      }
    }

    if (reportRange === "today" || reportRange === "yesterday") {
      fetchOrders();
    } else {
      fetchBulkData();
    }
  }, [reportRange, Logout]);

  return (
    // RESPONSIVE FIX: Dynamic padding based on screen size
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 },width:'100%',maxWidth:{xs: '350px', sm: '100%', md: '100%'} }}>
      
      {/* RESPONSIVE FIX: Smaller font on mobile */}
      <Typography 
        variant="h4" 
        gutterBottom
        sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
      >
        POS Reports
      </Typography>

      {/* RESPONSIVE FIX: Scrollable tabs for mobile */}
      <Tabs
        value={tabIndex}
        onChange={(e, newIndex) => setTabIndex(newIndex)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {reportTabs.map((label, index) => (
          <Tab label={label} key={index} />
        ))}
      </Tabs>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid 
          container 
          spacing={2} 
          // RESPONSIVE FIX: Default to 'flex-start' on mobile for natural flow, 'flex-end' on desktop
          sx={{
            justifyContent: { xs: "flex-start", md: "flex-end" },
            alignItems: "center",
            
          }}
        >
          {tabIndex === 4 && (
            <>
              {/* RESPONSIVE FIX: xs=12 (stacked), sm=6 (2 per row), md=3 (4 per row) */}
              <Grid item xs={12} sm={6} md={3}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newVal) => {
                    const properDate = new Date(newVal);
                    properDate.setHours(0, 0, 0, 0);
                    setStartDate(properDate);
                  }}
                  onAccept={() => setUpdateDate(!updateDate)}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newVal) => {
                    const properDate = new Date(newVal);
                    properDate.setHours(23, 59, 59, 999);
                    setEndDate(properDate);
                  }}
                  onAccept={() => setUpdateDate(!updateDate)}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small" />
                  )}
                />
              </Grid>
            </>
          )}

          {/* Report Range Dropdown */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel id="report-range-label">Report Range</InputLabel>
              <Select
                labelId="report-range-label"
                value={reportRange}
                label="Report Range"
                onChange={(e) => setReportRange(e.target.value)}
              >
                {reportRanges.map((range) => (
                  <MenuItem value={range.value} key={range.value}>
                    {range.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <br />
      </LocalizationProvider>

      <Box sx={{ mt: 3 ,width:'100%'}}>
        {tabIndex === 0 && (
          <SalesReport reportRange={reportRange} rawData={serverData} />
        )}
        {tabIndex === 1 && (
          <OrderReport reportRange={reportRange} rawData={serverData} />
        )}
        {tabIndex === 2 && (
          <PaymentReport reportRange={reportRange} rawData={serverData} />
        )}
        {tabIndex === 3 && (
          <EmployeeShiftReport reportRange={reportRange} />
        )}
        {tabIndex === 4 && (
          <CustomReports 
            storeID={storeID.current} 
            startDate={startDate} 
            endDate={endDate} 
            rawDataParent={rawServerData} 
          />
        )}
      </Box>
    </Box>
  );
};

export default ReportPage;
